<div class="table">
    <table>
        <thead>
            <tr>
                <th class="sno">S. No.</th>
                <th class="post-image">Image</th>
                <th class="post-title">Title</th>
                <th class="post-description">Description</th>
                <th class="posted-on">Posted On</th>
                <th class="posted-by">Posted By</th>
                <th class="action-block"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="
                    let data of tableData
                    | paginate: { itemsPerPage: 10, currentPage: page };
                    let i = index
                    ">
                <td class="sno">{{ page * 10 - 10 + (i + 1) }}</td>
                <td class="post-image">
                    <img src="{{data.imageUrls[0]}}" />
                </td>
                <td class="post-title">
                    <!-- <img class="table-title-block__circle-image" src="{{ data.imageUrls.length !== 0 ? data.imageUrls[0] : '' }}" /> -->
                    <div>{{ data.title }}</div>
                </td>
                <td class="post-description">{{ data.description }}</td>
                <td class="posted-on">{{ data.postedDate }}</td>
                <td class="posted-by">{{ data.postedBy }}</td>
                <td class="action-block">
                    <div (click)="onViewClick(data)">
                        <ng-container *ngTemplateOutlet="viewIcon"></ng-container>
                    </div>
                    <div (click)="onEditClick(data)">
                        <ng-container *ngTemplateOutlet="editIcon"></ng-container>
                    </div>
                    <div (click)="onDeleteClick(data)">
                        <ng-container *ngTemplateOutlet="deleteIcon"></ng-container>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<ng-template #deleteIcon>
    <svg viewBox="0 0 24 24" class="delete-icon">
        <path
            d="m18.5 24h-13c-1.379 0-2.5-1.122-2.5-2.5v-14c0-.276.224-.5.5-.5h17c.276 0 .5.224.5.5v14c0 1.378-1.121 2.5-2.5 2.5zm-14.5-16v13.5c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-13.5z" />
        <path
            d="m22.5 8h-21c-.276 0-.5-.224-.5-.5v-2c0-1.378 1.121-2.5 2.5-2.5h17c1.379 0 2.5 1.122 2.5 2.5v2c0 .276-.224.5-.5.5zm-20.5-1h20v-1.5c0-.827-.673-1.5-1.5-1.5h-17c-.827 0-1.5.673-1.5 1.5z" />
        <path
            d="m15.5 4h-7c-.276 0-.5-.224-.5-.5v-2c0-.827.673-1.5 1.5-1.5h5c.827 0 1.5.673 1.5 1.5v2c0 .276-.224.5-.5.5zm-6.5-1h6v-1.5c0-.276-.225-.5-.5-.5h-5c-.275 0-.5.224-.5.5z" />
        <path d="m7.5 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z" />
        <path d="m12 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z" />
        <path d="m16.5 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z" />
    </svg>
</ng-template>

<ng-template #editIcon>
    <svg class="table-edit-icon" viewBox="0 0 24 24">
        <g id="XMLID_1_">
            <path
                d="m22.06 7.6-14 13.99c.2-.19.2-.51 0-.7l-.35-.35 13.29-13.3-.35-.35c.09.09.22.15.35.15s.26-.06.35-.15l.36-.35.35.35c.19.19.19.51 0 .71z" />
            <path
                d="m23.12 5.12-1.41 1.42-.71-.71 1.41-1.42c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.41c-.77-.78-2.05-.78-2.82 0l-1.42 1.41-.7-.7 1.41-1.42c1.17-1.17 3.07-1.17 4.24 0 .57.57.88 1.32.88 2.12s-.31 1.55-.88 2.12z" />
            <path
                d="m21 5.83.71.71-.36.35c-.09.09-.22.15-.35.15s-.26-.06-.35-.15l-3.54-3.54c-.19-.19-.19-.51 0-.7l.36-.35.7.7z" />
            <path
                d="m15.69 3.35-.35-.35 1.06-1.06c.19-.19.52-.19.71 0l.36.36-.36.35c-.19.19-.19.51 0 .7l-.35-.35-1.06 1.07-.01-.01c.2-.19.2-.51 0-.71z" />
            <path d="m15.34 3 .35.35c.2.2.2.52 0 .71-.19.2-.51.2-.7 0l-.35-.35z" />
            <path d="m7.9 21.7c.06-.02.12-.06.16-.11-.04.05-.1.08-.16.11z" />
            <path
                d="m7.71 21.74c-.13 0-.26-.05-.35-.15l-.58-.58.67-.21.26-.26.35.35c.2.19.2.51 0 .7-.04.05-.1.09-.16.11-.06.03-.12.04-.19.04z" />
            <path
                d="m12.16 3.35-4.95 4.95c-.1.1-.22.15-.35.15s-.26-.05-.36-.15c-.19-.19-.19-.51 0-.7l4.95-4.95c.95-.95 2.6-.95 3.54 0l.35.35-.7.71-.36-.36c-.56-.56-1.55-.56-2.12 0z" />
            <path d="m3.47 16.29 4.24 4.25-.26.26-.67.21-3.79-3.79.21-.66z" />
            <path
                d="m3.2 16.56-.21.66-.58-.58c-.15-.14-.19-.36-.11-.54.02-.06.06-.11.11-.16.19-.2.51-.2.71 0l.35.35z" />
            <path d="m15.7 4.07-12.23 12.22-.35-.35c-.2-.2-.52-.2-.71 0l12.23-12.23.35.35c.19.2.51.2.7 0z" />
            <path d="m2.41 15.94c-.05.05-.09.1-.11.16.03-.06.06-.12.11-.16z" />
            <path
                d="m7.86 21.72-7.21 2.26c-.05.01-.1.02-.15.02-.13 0-.26-.05-.35-.15-.14-.13-.18-.32-.13-.5l2.26-7.21c.01-.01.01-.03.02-.04-.08.18-.04.4.11.54l.58.58-1.73 5.52 5.52-1.73.58.58c.09.1.22.15.35.15.07 0 .13-.01.19-.04-.01.01-.03.01-.04.02z" />
        </g>
    </svg>
</ng-template>

<ng-template #viewIcon>
    <svg class="view-icon" viewBox="0 0 512 512">
        <g>
            <g>
                <path d="M510.677,251.069c-25.39-43.889-61.9-80.699-105.581-106.45C360.087,118.087,308.53,104.062,256,104.062
                                 s-104.087,14.025-149.095,40.557C63.223,170.37,26.714,207.18,1.323,251.069c-1.764,3.05-1.764,6.811,0,9.861
                                 c25.39,43.889,61.9,80.699,105.581,106.45c45.009,26.532,96.565,40.557,149.095,40.557s104.087-14.025,149.095-40.557
                                 c43.681-25.751,80.191-62.56,105.581-106.45C512.441,257.88,512.441,254.12,510.677,251.069z M256,388.244
                                 c-95.715,0-185.117-50.529-234.71-132.245C70.883,174.284,160.285,123.755,256,123.755s185.117,50.529,234.71,132.245
                                 C441.117,337.716,351.715,388.244,256,388.244z" />
            </g>
        </g>
        <g>
            <g>
                <path d="M256,137.846c-65.15,0-118.154,53.004-118.154,118.154S190.85,374.153,256,374.153s118.154-53.004,118.154-118.154
                                 S321.15,137.846,256,137.846z M256,354.461c-54.293,0-98.462-44.17-98.462-98.462s44.169-98.462,98.462-98.462
                                 s98.462,44.17,98.462,98.462S310.293,354.461,256,354.461z" />
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M315.077,246.011c-5.437,0-9.846,4.408-9.846,9.846v0.143c0,5.438,4.409,9.846,9.846,9.846
                                 c5.437,0,9.846-4.408,9.846-9.846v-0.144C324.923,250.419,320.515,246.011,315.077,246.011z" />
            </g>
        </g>
        <g>
            <g>
                <path d="M315.525,221.238c-12.327-21.071-35.136-34.161-59.525-34.161c-5.437,0-9.846,4.408-9.846,9.846
                                 c0,5.438,4.409,9.846,9.846,9.846c17.422,0,33.718,9.354,42.529,24.413c1.831,3.131,5.124,4.876,8.508,4.876
                                 c1.689,0,3.4-0.434,4.962-1.349C316.693,231.962,318.271,225.93,315.525,221.238z" />
            </g>
        </g>
    </svg>
</ng-template>